import React from "react";
import {
  AddBusinessOutlined,
  Close,
  ContactPhoneOutlined,
  Group,
  PersonAddAltOutlined,
  AssignmentIndOutlined,
} from "@mui/icons-material";
import { IconButton, List, ListItem } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useContext, useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";

import { EventsDispatchContext } from "../../../context/EventsProvider";
import { inject } from "../../../../lib/itn-ui-kit/services/service-container";
import { setUIError } from "../../../../state/actions";
import DataContext from "../../../context/DataContext";
import Svg, { SvgEnum } from "../../ui library/components/svgs/standard/svg";
import FlyoutMenu from "../../ui library/components/menus/flyout-menu";
import { MainNavBarEnum } from "./MainNavBarEnum";
import SideBarMenuItem from "./SideBarMenuItem";
import { GROUPS } from "../../../../globalConstants";
import { useHistoryNavigate } from "../../../hooks/useHistoryNavigate";

export default function SideBarMain({ activeRoute }) {
  const currentUserService = inject("current-user-service");
  const landingService = inject("landing-service");
  const { selectedClient } = useContext(DataContext);
  const eventDispatch = useContext(EventsDispatchContext);
  const { navigationHistoryService } = useHistoryNavigate();

  const location = useLocation();
  const [open, setOpen] = useState(false);
  const dashboardDefault =
    "/search?offset=0&limit=100&overall_status__in=Active%2CActive+-+Client+Unresponsive%2CActive+-+Paused+%28See+Note%29%2CActive+-+Waiting+on+Limits";

  const getCaseSearchUrl = () => {
    if (localStorage.getItem("Search")) {
      return localStorage.getItem("Search");
    } else {
      return dashboardDefault;
    }
  };

  const isActivePath = (url) => {
    if (process.env.REACT_APP_API_URL) {
      let currentLoc = new URL(url, process.env.REACT_APP_API_URL);
      if (location.pathname === currentLoc.pathname) {
        return true;
      }
    }
    return false;
  };

  const BUTTON_TYPE = {
    DEFAULT: "DEFAULT",
    FLYOUT: "FLYOUT",
  };

  const getButtonType = (type) => {
    switch (type) {
      case MainNavBarEnum.USER_MANAGER:
        return BUTTON_TYPE.FLYOUT;
      default:
        return BUTTON_TYPE.DEFAULT;
    }
  };


  const generateUserMenuData = () => {
    let userMenuArr = [];

    if (currentUserService?.userRoles.permissions.includes("users.add_user")) {
      userMenuArr.push({
        icon: <PersonAddAltOutlined className="text-black" />,
        title: "Add User",
        order: 1,
        url: "/add-application-user",
      });
    }
    if (currentUserService?.userRoles.permissions.includes("users.view_user")) {
      userMenuArr.push(
        {
          icon: <Group className="text-black" />,
          title: "View/Manage Users",
          order: 2,
          url: "/user-profiles",
        },
        {
          icon: <ContactPhoneOutlined className="text-black" />,
          title: "Contacts",
          order: 4,
          url: "/contact",
        }
      );
    }
    if (
      currentUserService?.userRoles.permissions.includes(
        "provider.change_provider"
      )
    ) {
      userMenuArr.push({
        icon: <AssignmentIndOutlined className="text-black" />,
        title: "View/Manage Providers",
        order: 3,
        url: "/providers",
      });
    }
    if (
      currentUserService?.userRoles.permissions.includes("lawyer.add_lawfirm")
    ) {
      userMenuArr.push({
        icon: <AddBusinessOutlined className="text-black" />,
        title: "Add Law Firm",
        order: 5,
        url: "/create-law-firm",
      });
    }
    return userMenuArr.sort((a, b) => a.order - b.order);
  };

  const renderIcon = () => {
    if (open) {
      return <Close style={{ fontSize: "40px" }} />;
    }
    return <MenuIcon style={{ fontSize: "40px" }} />;
  };

  const renderCloseIcon = () => {
    if (!open) {
      return null;
    }
    return <Close className="md:text-[40px] text-[30px] self-center" />;
  };

  const addNavItem = (menuArr, name) => {
    switch (name) {
      case "dashboard":
        if (
          currentUserService?.userRoles.permissions.includes(
            "casemanager.view_case"
          )
        ) {
          menuArr.push({
            key: MainNavBarEnum.DASHBOARD,
            title: "DASHBOARD",
            url: landingService.PriorityAccessibleRoute,
            icon: SvgEnum.HisDashboard,
            order: 1,
            type: getButtonType(MainNavBarEnum.DASHBOARD),
          });
        }
        break;

      case "search-clients":
        if (
          currentUserService?.userRoles.permissions.includes(
            "casemanager.view_case"
          )
        ) {
          menuArr.push({
            key: MainNavBarEnum.SEARCH_CLIENTS,
            title: "SEARCH CLIENTS",
            url: getCaseSearchUrl(),
            icon: SvgEnum.HisSearch,
            order: 2,
            type: getButtonType(MainNavBarEnum.SEARCH_CLIENTS),
          });
        }
        break;

      case "add-client":
        if (
          currentUserService?.userRoles.permissions.includes(
            "casemanager.add_case"
          )
        ) {
          menuArr.push({
            key: MainNavBarEnum.ADD_CLIENT,
            title: "ADD CLIENT",
            url: "/add-client",
            icon: SvgEnum.HisPersonAdd,
            order: 3,
            type: getButtonType(MainNavBarEnum.ADD_CLIENT),
          });
        }
        break;

      case "provider-map":
        if (
          currentUserService?.userRoles.permissions.includes(
            "provider.add_providerclientstatus"
          )
        ) {
          menuArr.push({
            key: MainNavBarEnum.PROVIDER_MAP,
            title: "PROVIDER MAP",
            url: "/provider-map",
            icon: SvgEnum.HisMapMarker,
            order: 4,
            type: getButtonType(MainNavBarEnum.PROVIDER_MAP),
          });
        }
        break;

      case "appointment-calendar":
        if (
          currentUserService?.userRoles.permissions.includes(
            "provider.view_appointment"
          ) ||
          currentUserService?.userRoles.permissions.includes(
            "provider.view_appointments_related_to_treating_clients"
          ) ||
          currentUserService?.userRoles.permissions.includes(
            "provider.view_appointments_related_to_assigned_clients"
          )
        ) {
          menuArr.push({
            key: MainNavBarEnum.APPOINTMENT_CALENDAR,
            title: "APPT CALENDAR",
            url: "/appointment-calendar",
            icon: SvgEnum.HisCalendar,
            order: 5,
            type: getButtonType(MainNavBarEnum.APPOINTMENT_CALENDAR),
          });
        }
        break;

      case "analytics":
        if (
          currentUserService?.userRoles.permissions.includes(
            "provider.view_appointment"
          ) ||
          currentUserService?.userRoles.permissions.includes(
            "provider.view_appointments_related_to_treating_clients"
          ) ||
          currentUserService?.userRoles.permissions.includes(
            "provider.view_appointments_related_to_assigned_clients"
          )
        ) {
          menuArr.push({
            key: MainNavBarEnum.ANALYTICS,
            title: "ANALYTICS",
            url: "/analytics",
            icon: SvgEnum.HisChart,
            order: 6,
            type: getButtonType(MainNavBarEnum.ANALYTICS),
          });
        }
        break;

      case "client-detail":
        if (
          currentUserService?.userRoles.permissions.includes(
            "casemanager.view_case"
          )
        ) {
          menuArr.push({
            key: MainNavBarEnum.CLIENT_DETAIL,
            title: "CLIENT DETAIL",
            url: `/client-detail/${selectedClient}`,
            icon: SvgEnum.HisLastClient,
            order: 7,
            type: getButtonType(MainNavBarEnum.CLIENT_DETAIL),
            handlerFn: !selectedClient
              ? () =>
                  setUIError(eventDispatch, {
                    uiError: true,
                    uiErrorMessage:
                      "Please Select a Client to View Client's Details...",
                  })
              : undefined,
          });
        }
        break;

      case "reports":
        menuArr.push({
          key: MainNavBarEnum.REPORTS,
          title: "REPORTS",
          url: "/reports/list",
          icon: SvgEnum.HisChart,
          order: 8,
          type: getButtonType(MainNavBarEnum.REPORTS),
        });
        break;
      case "user-manager":
          if (currentUserService?.userRoles.permissions.includes("users.view_user")) {
            menuArr.push({
              key: MainNavBarEnum.USER_MANAGER,
              title: "USER MANAGER",
              url: "",
              icon: SvgEnum.HisPeople,
              order: 10,
              type: getButtonType(MainNavBarEnum.USER_MANAGER),
              id: "user-manager-menu-popup",
              menuItems: generateUserMenuData()
            });
          }
          break;

      default:
        throw new Error(`${name} is not a valid option in 'addNavItem'`);
    }
  };
  
  const generateMenuData = () => {
    let menuArr = [];

    addNavItem(menuArr, MainNavBarEnum.DASHBOARD);
    if(currentUserService.accessibleRoutes.includes(GROUPS.MCC)){
      addNavItem(menuArr, MainNavBarEnum.SEARCH_CLIENTS);
    }
    // addNavItem(menuArr, MainNavBarEnum.ADD_CLIENT);
    addNavItem(menuArr, MainNavBarEnum.PROVIDER_MAP);
    addNavItem(menuArr, MainNavBarEnum.APPOINTMENT_CALENDAR);
    addNavItem(menuArr, MainNavBarEnum.ANALYTICS);
    addNavItem(menuArr, MainNavBarEnum.CLIENT_DETAIL);
    addNavItem(menuArr, MainNavBarEnum.REPORTS);
    addNavItem(menuArr, MainNavBarEnum.USER_MANAGER);

    return menuArr;
  };

  const Menus = !currentUserService?.userRoles.permissions
    ? []
    : generateMenuData();

  
  return (
    <>
      <div className="fixed z-10 flex items-center justify-between w-full bg-white shadow-lg sm:hidden">
        <div className="w-1/3">
          <IconButton
            className="block pl-2 w-[100px]"
            onClick={() => setOpen(!open)}
          >
            {renderIcon()}
          </IconButton>
        </div>
        <div className="w-1/3">&nbsp;</div>
      </div>
      <div className="fixed z-50 flex bg-white shadow-lg">
        <IconButton
          className="absolute z-10 block pl-2 m-4 sm:hidden"
          onClick={() => setOpen(!open)}
        >
          {renderCloseIcon()}
        </IconButton>
        <div
          className={`w-0 ${
            open ? "sm:w-64" : "sm:w-16"
          }  h-screen relative duration-300 bg-white`}
        >
          <div
            className={`sm:flex flex-col items-center ${
              open
                ? "w-[100vw] sm:w-64 h-[100vh] bg-white overflow-y-auto border-r"
                : "hidden"
            }`}
          >
            <List
              className={`p-0 bg-white sm:bg-white/[0] flex flex-col w-full h-full [&>li]:p-0 items-center gap-4 ${
                open ? "" : "[&>li>a]:justify-center"
              }`}
            >
              <li className="flex p-2 mt-3 text-sm text-black rounded-md cursor-pointer MuiListItem-root MuiListItem-gutters MuiListItem-padding hover:bg-light-white gap-x-4 bg-light-white css-1p823my-MuiListItem-root">
                <span
                  className={`flex gap-6 items-center px-4 py-2 rounded-md  hover:text-white ${
                    open ? "" : "justify-center"
                  } w-full`}
                >
                  <Svg
                    name="his-list-sort"
                    onClick={() => {
                      setOpen(!open);
                    }}
                  />
                </span>
              </li>
              {[...Menus]
                .sort((a, b) => a.order - b.order)
                .map((Menu, index) => {
                  return (
                    <ListItem
                      key={index}
                      className={`${
                        open ? "px-4 h-[50px]" : "p-0"
                      } flex rounded-md cursor-pointer hover:bg-light-white text-black text-sm items-center justify-between`}
                    >
                      {Menu.type === BUTTON_TYPE.FLYOUT ? (
                        <FlyoutMenu
                          id={Menu.id}
                          icon={<Svg name={Menu.icon} />}
                          label={Menu.title}
                          menuItems={Menu.menuItems}
                          isOpen={open}
                          showTopDivider={index === Menus.length-1}
                        />
                      ) : (
                        <SideBarMenuItem
                          Menu={Menu}
                          index={index}
                          isActivePath={isActivePath}
                          open={open}
                          setOpen={setOpen}
                          activeRoute={activeRoute}
                        />
                      )}
                    </ListItem>
                  );
                })}
            </List>
          </div>
        </div>
      </div>
    </>
  );
}
